export enum PartnerType {
  Commission = 'commission',
  Distribution = 'distribution',
  DealPassing = 'deal_passing',
}
